
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt-br/ia/gestao-de-sinistros",
      function () {
        return require("private-next-pages/pt-br/ia/gestao-de-sinistros/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt-br/ia/gestao-de-sinistros"])
      });
    }
  